<div class="container-graph" [chart]="chart"></div>